/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Wizard_Step5_Sync_On_CreationInputs */



/**
* | output |
* | --- |
* | "Sync on Creation:" |
*
* @param {Spaces_Wizard_Step5_Sync_On_CreationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_wizard_step5_sync_on_creation = /** @type {((inputs?: Spaces_Wizard_Step5_Sync_On_CreationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Wizard_Step5_Sync_On_CreationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bei Erstellung synchronisieren:")
	return /** @type {LocalizedString} */ ("Sync on Creation:")
});